import React from 'react'
import {
    Flex,
    Text,
    Img,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'

//Disabled steps for not - to be revisited
//const RecipeStep = ({step, totalSteps}) => {
const RecipeStep = ({step}) => {
    const styles = useMultiStyleConfig('RecipeDetails', {})
    const {stepsMenu} = styles || {}

    return (
        <Flex {...stepsMenu?.stepContainer}>
            {step.step_title && <Text {...stepsMenu?.stepNumber}>{`${step.step_title}`}</Text>}
            {step?.step_media?.step_picture?.url && (
                <Flex {...stepsMenu?.stepImageContainer}>
                    <Img w="100%" src={step?.step_media?.step_picture?.url} />
                </Flex>
            )}
            <Flex flexDir="column" width="100%">
                {parse(step?.instructions || '')}
            </Flex>
        </Flex>
    )
}
RecipeStep.propTypes = {
    step: PropTypes.object,
    totalSteps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default RecipeStep
